export default {"src":"/login-app/[GIT_HASH]/_next/static/media/thumb_up.36e205de.svg","height":24,"width":24,"blurWidth":0,"blurHeight":0};